import type { ComponentPropsWithoutRef } from "react";
import { tv } from "tailwind-variants";

const messageVariants = tv({
  base: "block py-1 text-left text-xs text-content-muted",
  variants: {
    error: {
      true: "font-medium text-danger-content",
    },
  },
});

export type MessageProps = {
  message?: string;
  error?: string | boolean;
  /* Hold an empty line so the field does not shift when a message appears. */
  reserveSpace?: boolean;
} & ComponentPropsWithoutRef<"p">;

export const Message = ({ className, error, message, ...props }: MessageProps) => {
  const text = error === true ? "" : (error ?? message ?? "");
  const isError = Boolean(error);

  return (
    <p
      {...props}
      className={messageVariants({ className, error: isError })}
      /*
        Errors surface after the user has already moved on from the field, so they
        have to be announced; hints are read from aria-describedby on focus instead.
      */
      role={isError ? "alert" : undefined}
    >
      {/* Zero-width space holds the line's height so the layout doesn't jump. */}
      {text || "​"}
    </p>
  );
};
